// Thousands/millions steps for `compact`. Ordered high → low so the first hit
// is the right unit.
const COMPACT_UNITS = [
  { limit: 1e12, suffix: "T" },
  { limit: 1e9, suffix: "B" },
  { limit: 1e6, suffix: "M" },
  { limit: 1e3, suffix: "K" },
];

/**
 * `fractionDigits` drops the cents where they only add noise (pass 0 on cards
 * and other dense summary surfaces).
 *
 * `compact` abbreviates to a unit instead: 183000 → "$183K", 1700000 → "$1.7M".
 * One decimal below ten units, none above, so column totals stay narrow without
 * collapsing distinct amounts into the same string.
 */
const formatDollar = (
  value,
  returnVal = "—",
  { fractionDigits = 2, compact = false } = {},
) => {
  if (value === null || value === undefined || value === "") return returnVal;
  const n = typeof value === "number" ? value : Number(value);
  if (Number.isNaN(n)) return returnVal;
  const sign = n < 0 ? "-" : "";
  const abs = Math.abs(n);

  if (compact) {
    const unit = COMPACT_UNITS.find((u) => abs >= u.limit);
    if (!unit) return `${sign}$${Math.round(abs)}`;
    const scaled = abs / unit.limit;
    const text = scaled.toFixed(scaled < 10 ? 1 : 0).replace(/\.0$/, "");
    return `${sign}$${text}${unit.suffix}`;
  }

  const formatted = abs.toLocaleString("en-US", {
    minimumFractionDigits: fractionDigits,
    maximumFractionDigits: fractionDigits,
  });
  return `${sign}$${formatted}`;
};

export default formatDollar;
